import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-mapfre-input',
  templateUrl: './mapfre-input.component.html',
  styleUrls: ['./mapfre-input.component.scss'],
})
export class MapfreInputComponent implements OnInit {

  @ViewChild('inputElement') inputElement: ElementRef;

  @Output() controlIsValid: EventEmitter<boolean>;
  @Output() inputFocus: EventEmitter<string | number>;
  @Output() inputBlur: EventEmitter<string | number>;
  @Output() inputChange: EventEmitter<string | number>;

  @Input() type: 'text' | 'number' | 'tel' | 'email' | 'password';
  @Input() control: FormControl;
  @Input() classList: string;
  @Input() label: string;
  @Input() maxLength: number;
  @Input() placeholder: string;
  @Input() errorText: string;
  @Input() disabled: boolean;
  @Input() readonly: boolean;
  @Input() required: boolean;
  @Input() hasErrors: boolean;
  @Input() noDirtyError = false;
  @Input() showHint: boolean;
  @Input() showHintErrors: boolean;
  @Input() showPassword: boolean;
  @Input() mt: string | number;
  @Input() toUpperCase: boolean;
  @Input() autocomplete: 'on' | 'off' = 'on';

  // Name of icon without extension. Must be exists in `assets/icons/functional` as `svg`
  @Input() iconName: string;
  @Input('value') set value(v: number | string) {
    if (v) {
      this.inputValue = v;
    }
  }

  inputValue: number | string;
  hasFocus: boolean;
  constructor() {
    this.showHintErrors = true;
    this.showPassword = false;
    this.inputValue = '';
    this.placeholder = '';
    this.type = 'text';
    this.maxLength = null;
    this.mt = '11';
    this.toUpperCase = false;
    this.controlIsValid = new EventEmitter();
    this.inputFocus = new EventEmitter();
    this.inputBlur = new EventEmitter();
    this.inputChange = new EventEmitter();
  }

  ngOnInit() {
    this.setInputValue();
  }

  onKeyDown(event: any) {
    if (event.code === 'Enter') {
      this.inputElement.nativeElement.blur();
    }
    if (event.code === 'KeyV') {
      return;
    }
    this.handlerFormControl(this.inputValue);
  }

  onInputPaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || window['clipboardData'];
    if (clipboardData) {
      if (this.maxLength) {
        this.inputValue = clipboardData.getData('text').trim().substr(0, this.maxLength);
      } else {
        this.inputValue = clipboardData.getData('text').trim();
      }
      this.inputElement.nativeElement.blur();
      this.handlerFormControl(this.inputValue);
    }
  }

  onInputChange(e) {
    this.inputChange.emit(this.inputValue);
  }

  onInputFocus() {
    this.hasFocus = true;
    this.inputFocus.emit(this.inputValue);
  }

  onInputBlur() {
    this.hasFocus = false;
    this.control?.markAsDirty();
    this.inputBlur.emit(this.inputValue);
    this.handlerFormControl(this.inputValue);
  }

  getInputValue(v) {
    if (this.toUpperCase && typeof v === 'string') {
      return v.toUpperCase();
    }
    return v;
  }

  private handlerFormControl(value: string | number) {
    if (!this.control) { return; }
    this.control.setValue(value);
    this.control.markAsTouched();
    this.controlIsValid.emit(this.control.valid);
  }

  private setInputValue() {
    if (this.control) {
      this.inputValue = this.control.value;
    }
  }
}
